import { useTranslation } from 'react-i18next';
import { ShieldAlert } from 'lucide-react';

/**
 * Rendered for the (rare) case where the selected gym grants the user a staff
 * role that maps to no menu entry (e.g. judge-only). Switching gyms in the
 * sidebar can reveal sections again.
 */
export default function NoAccess() {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col items-center justify-center gap-3 py-24 text-center">
      <div className="flex size-14 items-center justify-center rounded-full bg-muted">
        <ShieldAlert className="size-7 text-muted-foreground" />
      </div>
      <h2 className="text-lg font-semibold">{t('gymAdmin.noAccess.title')}</h2>
      <p className="max-w-md text-sm text-muted-foreground">{t('gymAdmin.noAccess.description')}</p>
    </div>
  );
}
